import { ShieldAlert } from "lucide-react";
import { Component, ReactNode } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface Props extends WithTranslation {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundaryComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { t } = this.props;

    if (this.state.hasError) {
      return (
        <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm p-4 z-50">
          <div className="flex flex-col items-center justify-center p-8 bg-white rounded-xl shadow-lg border max-w-md w-full animate-in fade-in-50 duration-300">
            <ShieldAlert className="w-16 h-16 text-destructive mb-6" />
            <h3 className="text-xl font-semibold text-destructive mb-3">
              {this.state.error?.message || t("common.errors.occurred")}
            </h3>
            <p className="text-muted-foreground text-center mb-6">
              {t("common.errors.tryAgainOrContact")}
            </p>
            <div className="flex gap-4">
              <Button variant="outline" onClick={() => window.history.back()}>
                {t("common.back")}
              </Button>
              <Button onClick={this.handleReload}>{t("common.retry")}</Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withTranslation()(ErrorBoundaryComponent);
